import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { getApiBaseUrl } from '../../utils/apiBaseUrl';
import { getUtmParamsForApi } from '../../utils/utmTracker';
import { getWebsiteThemeAttribution } from '../../experiments/websiteTheme';
import { getChallengeGoogleAdsConsent } from '../challenges/challengeQualifyingLead';
import './CoursePage.css';

const openProviderCalendar = (url) => window.location.assign(url);

/** A direct course visitor can book without creating an app/challenge account.
 * Saving this context is not an appointment; the provider webhook confirms it. */
export default function CourseBookingPage({ openCalendar = openProviderCalendar }) {
  const [attempt, setAttempt] = useState(0);
  const [failed, setFailed] = useState(false);
  useEffect(() => {
    let mounted = true;
    setFailed(false);
    (async () => {
      try {
        const response = await fetch(
          `${getApiBaseUrl() || 'https://api.botspot.trade'}/calendly/course-booking-context`,
          {
            method: 'POST',
            keepalive: true,
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              ...getUtmParamsForApi(),
              ...getWebsiteThemeAttribution(),
              googleAdsConsent: getChallengeGoogleAdsConsent(),
              posthog_distinct_id: window.posthog?.get_distinct_id?.(),
              landingPage: 'https://botspot.trade/courses/ai-trading-bootcamp',
            }),
          },
        );
        if (!response.ok) throw new Error('calendar_unavailable');
        const result = await response.json();
        const url = new URL(result.url);
        if (
          url.origin !== 'https://calendly.com' ||
          url.pathname !== '/lumiwealth/botspot-call' ||
          url.searchParams.get('utm_source') !== 'ai_trading_bootcamp'
        )
          throw new Error('invalid_calendar');
        if (mounted) openCalendar(url.toString());
      } catch {
        if (mounted) setFailed(true);
      }
    })();
    return () => {
      mounted = false;
    };
  }, [attempt, openCalendar]);
  return (
    <main className="course-page" data-testid="course-booking-page">
      <Helmet>
        <title>Talk with Rob about the Bootcamp | BotSpot</title>
        <meta name="robots" content="noindex, follow" />
      </Helmet>
      <div className="chp-form-card" style={{ maxWidth: 560, margin: '40px auto', padding: 24 }}>
        <h1>Talk with Rob about the Bootcamp</h1>
        {failed ? (
          <>
            <p role="alert">The calendar could not open. Please try again.</p>
            <button className="cp-btn-primary" onClick={() => setAttempt((value) => value + 1)}>
              Try again
            </button>
          </>
        ) : (
          <p role="status">Opening available call times…</p>
        )}
      </div>
    </main>
  );
}
